import React, { useContext } from 'react';
// import styles from './App.module.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import { Alert, Snackbar } from '@mui/material';
import './pages/HomePage/global.css'
import { UniversalContext } from './context/UniversalContext/UniversalContext';
import AyurvedicEncyclopedia from './pages/AyurvedicEncyclopedia/AyurvedicEncyclopedia';
import HomeopathicEncyclopedia from './pages/HomeopathicEncyclopedia/HomeopathicEncyclopedia';
import SymptomsChecker from './pages/SymptomsChecker/SymptomsChecker';
import PractitionerDirectory from './pages/PractitionerDirectory/PractitionerDirectory';
import Blog from './pages/Blog/Blog';
import RemediesGuide from './pages/RemediesGuide/RemediesGuide';
import MeditationGuide from './pages/MeditationGuide/MeditationGuide';
import NavbarContained from './components/NavbarContained/NavbarContained';
import Footer from './components/Footer/Footer';
import Practitioner from './pages/PractitionerDirectory/Practitioner';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import { Wrapper } from './components/Wrapper/Wrapper';

function App() {
  const { alert } = useContext(UniversalContext)
  return (
    <Router>
        <Routes>
          <Route path='/' element={<HomePage />}></Route>
          <Route path='/ayurvedic-encyclopedia' element={
            <>
              <NavbarContained />
              <AyurvedicEncyclopedia />
              <Footer />
            </>
          }></Route>
          <Route path='/homeopathy-encyclopedia' element={
            <>
              <NavbarContained />
              <HomeopathicEncyclopedia />
              <Footer />
            </>
          }></Route>
          <Route path='/symptoms-checker' element={
            <>
              <NavbarContained />
              <SymptomsChecker />
              <Footer />
            </>
          }></Route>
          <Route path='/practitioners-directory' element={
            <>
              <NavbarContained />
              <Practitioner />
              <Footer />
            </>
          }></Route>
          <Route path='/blog' element={
            <>
              <NavbarContained />
              <Blog />
              <Footer />
            </>
          }></Route>
          <Route path='remedies-guides' element={
            <>
              <NavbarContained />
              <RemediesGuide />
              <Footer />
            </>
          }></Route>
          <Route path='meditation-guides' element={
            <>
              <NavbarContained />
              <MeditationGuide />
              <Footer />
            </>
          }></Route>
          <Route path='/about' element={<About />}></Route>
          <Route path='/contact' element={<Contact />}></Route>
        </Routes>
        {
          alert &&
          <Snackbar open={true} autoHideDuration={6000} onClose={false}>
            <Alert onClose={false} severity="success" sx={{ width: '100%' }}>
              Form Submitted Successfully!
            </Alert>
          </Snackbar>
        }
    </Router>

  );
}

export default App;
